import { computed, toRefs } from '@nuxtjs/composition-api';
import ItemsJS from 'itemsjs'
import { storeToRefs } from 'pinia';
import { useSearchStore } from '~/stores/useSearchStore';
import useTracking from '~/composable/tracking/useTracking';

// store index
let itemsjs = {}

export default function useSearch (appContext) {
  const app = appContext || useContext()
  const { track } = useTracking(app)

  const searchStore = useSearchStore()
  const {
    fitsWith,
    configurations,
    activeCategorySlug,
    listToFilter,
    itemSearchResult,
    query
  } = storeToRefs(searchStore)

  const setQueryParams = (router, route) => () => {
    const filterQuery = Object.keys(searchStore.state?.searchFilters).reduce((acc, cur) => {
      if (searchStore.state.searchFilters[cur].length) {
        acc['filter-' + cur] = searchStore.state.searchFilters[cur].join(',')
      }
      return acc
    }, {})

    router?.push({ path: route.path, query: { ...filterQuery } })
  }

  const setSearchFilters = (filters = {}) => {
    const newFilters = {}
    Object.keys(filters).forEach(key => {
      if ({ ...searchStore.rawFilters }[key]) {
        newFilters[key] = filters[key]
      }
    })
    searchStore.state.searchFilters = { ...searchStore.rawFilters, ...newFilters }
  }

  const resetFilters = () => {
    if (activeCategorySlug.value) {
      Object.keys(configurations.value.get(activeCategorySlug.value).aggregations).forEach(aggregation => {
        searchStore.state.searchFilters[aggregation] = []
      })
      $nuxt.$emit('filters-changed')
    }
    track('filtersClearAll')
  }

  const resetSearchResult = () => {
    itemSearchResult.value = {}
  }

  const resetListToFilter = () => {
    listToFilter.value = []
  }

  const setListToFilter = (list) => {
    listToFilter.value = list
  }

  const setQueryString = (queryString) => {
    query.value = queryString;
  }

  const createIndex = (categorySlug, productListFamily) => {
    // only recreate index if it doesn't exist
    // if (activeCategorySlug.value !== categorySlug || !process.browser)
    activeCategorySlug.value = categorySlug
    const currentConfig = configurations.value.get(categorySlug);
    itemsjs = ItemsJS(productListFamily, currentConfig)
  }

  const search = (productListFamily, categorySlug, categoryTree) => {
    if ((!process.browser && categorySlug === 'tilbehoer') || (categorySlug === 'tilbehoer' && activeCategorySlug.value !== categorySlug)) {
      searchStore.transformDataForAccessories(productListFamily, categoryTree)
    }

    searchStore.priceWithSubscriptionFiltering(productListFamily)

    createIndex(categorySlug, productListFamily)

    itemSearchResult.value = itemsjs.search({
      query: '', // queryString.value,
      filters: searchStore.state.searchFilters,
      per_page: 100
    })

    setQueryParams()

    return itemSearchResult.value
  }

  const mobileFiltersChanged = (filterName, filterVal, fitsWith) => {
    const index = searchStore.state.searchFilters[filterName].indexOf(filterVal)
    searchStore.state.searchFilters[filterName].splice(index, 1)
    // NLOS-2051 deselect subfilters when the brand tag is clicked - (it should only show the brand tag if brand/parent is selected)
    fitsWith[filterVal]?.forEach(val => mobileFiltersChanged(filterName, val, {}))
  }

  const isBooleanFilter = (filterName) => {
    return searchStore.booleanFilters.includes(filterName)
  }

  const isCategoryFilter = (filter) => {
    return searchStore.categoryFilters.includes(filter)
  }

  return {
    fitsWith,
    setQueryParams,
    setSearchFilters,
    state: toRefs(searchStore.state),
    resetFilters,
    configurations: computed(() => toRefs(configurations)),
    resetSearchResult,
    itemSearchResult,
    setQueryString,
    setListToFilter,
    resetListToFilter,
    search,
    mobileFiltersChanged,
    isBooleanFilter,
    isCategoryFilter
  }
}
